import { TextBase, TextBaseStyle } from "./base";
import styled from "@emotion/styled";
import React, { forwardRef } from "react";
import { css } from "@emotion/react";
import { FontFamily } from "../constants";
export const BodyBase = styled.p `
  ${({ fontWeight }) => TextBase(fontWeight)}
  color: ${({ theme }) => theme.colors.dark[500]};
  & p {
    font-family: ${FontFamily};
    margin: 0;
  }
`;
export const BodyInlineBase = styled.span `
  ${({ fontWeight }) => TextBase(fontWeight)}
  color: ${({ theme }) => theme.colors.dark[500]};

  & span {
    font-family: ${FontFamily};
    margin: 0;
  }
`;
export const Body1 = (props) => {
    const Base = props.inline ? BodyInlineBase : BodyBase;
    return (React.createElement(Base, Object.assign({}, props, { style: Object.assign({ lineHeight: "26px", fontSize: "17px" }, props.style) })));
};
export const Body2 = (props) => {
    const Base = props.inline ? BodyInlineBase : BodyBase;
    return (React.createElement(Base, Object.assign({}, props, { style: Object.assign({ lineHeight: "24px", fontSize: "16px" }, props.style) })));
};
export const Body3 = (props) => {
    const Base = props.inline ? BodyInlineBase : BodyBase;
    return (React.createElement(Base, Object.assign({}, props, { style: Object.assign({ lineHeight: "23px", fontSize: "15px" }, props.style) })));
};
export const Body4 = forwardRef((props, ref) => {
    const Base = props.inline ? BodyInlineBase : BodyBase;
    return (React.createElement(Base, Object.assign({}, props, { style: Object.assign({ lineHeight: "22px", fontSize: "14px" }, props.style), ref: ref })));
});
export const Body4Styles = css `
  ${TextBaseStyle};
  line-height: 22px;
  font-size: 14px;
`;
export const Body5Styles = css `
  ${TextBaseStyle};
  line-height: 21px;
  font-size: 13px;
`;
export const Body5 = (props) => {
    const Base = props.inline ? BodyInlineBase : BodyBase;
    return (React.createElement(Base, Object.assign({}, props, { style: Object.assign({ lineHeight: "21px", fontSize: "13px" }, props.style) })));
};
export const Body6 = (props) => {
    const Base = props.inline ? BodyInlineBase : BodyBase;
    return (React.createElement(Base, Object.assign({}, props, { style: Object.assign({ lineHeight: "20px", fontSize: "12px" }, props.style) })));
};
//# sourceMappingURL=Body.js.map